export default "__VITE_ASSET__CmcIB3dL__"